var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-key-value"},[_c('div',{staticClass:"key",style:({width:_vm.kw})},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"space",style:({width:typeof _vm.space === 'number'?_vm.space+'rem':_vm.space})}),_c('div',{staticClass:"value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }